import React, { Component } from "react";
import { FiChevronDown } from "react-icons/fi";
import { MdErrorOutline } from "react-icons/md";
import NumberFormat from "react-number-format";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { Cards } from "./services";

class CreditCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cards: [],
      cardDrop: false,
    };
  }

  componentDidMount() {
    this.getCards();
  }
  getCards() {
    Cards().then((items) => {
      items && this.setState({ cards: items.results });
    });
  }
  render() {
    return (
      <div className="col-12 px-0">
        <div
          id="cardBox"
          className={`row mx-0 p-3 mt-4 rounded14 ${
            this.props.cardError ? "border border-danger" : "border"
          }`}
        >
          <div className="col-auto px-0 align-self-center">
            <img
              src={
                require("../../../base/assets/icons/credit-card.svg").default
              }
            />
          </div>
          {this.props.cardError && (
            <div className="col-auto pe-2 align-self-center">
              <MdErrorOutline className="text-danger" size={17} />
            </div>
          )}
          <div className="col px-2">
            <NumberFormat
              value={this.props.cardNumber}
              onValueChange={(values) => {
                this.props.cardNumberChange(values.value);
              }}
              placeholder="----   ----   ----   ----"
              format="####   ####   ####   ####"
              mask="-"
              dir="ltr"
              onBlur={(e) =>
                e.target.value.replace(/ |-/gi, "").length !== 16
                  ? e.target.classList.add("text-danger")
                  : e.target.classList.remove("text-danger")
              }
              className="w-100 h-100 p-0 fs-5 border-0 fw-bold border-0 text-center"
            />
          </div>
          <div className="col-auto px-0 align-self-center">
            <Dropdown
              isOpen={this.state.cardDrop}
              toggle={() => this.setState({ cardDrop: !this.state.cardDrop })}
            >
              <DropdownToggle className="bg-white p-0 border-0">
                <FiChevronDown className="text-black-50" size={25} />
              </DropdownToggle>
              <DropdownMenu>
                {this.state.cards.map((card, c) => (
                  <section>
                    {c !== 0 && <DropdownItem divider />}
                    <DropdownItem
                      style={{ wordSpacing: "8px" }}
                      dir="ltr"
                      onClick={() => this.props.cardNumberChange(card.number)}
                    >
                      {card.number.replace(
                        /^(.{4})(.{4})(.{4})(.*)$/,
                        "$1 $2 $3 $4"
                      )}
                    </DropdownItem>
                  </section>
                ))}
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>
        {this.props.cardError && (
          <span className="text-danger small pe-3">
            {this.props.cardError[0].message}
          </span>
        )}
        <p className="small text-secondary mt-2 px-3">
          * شماره ی کارت برای واریز وجه سفارش به مشتریان نشان داده می شود.
          <br />
          *بعد از ثبت فروشگاه می توانید تنظیمات درگاه پرداخت (پرداخت اینترنتی) و
          پرداخت در محل را انجام دهید.
        </p>
      </div>
    );
  }
}

export default CreditCard;
